module.exports = __webpack_public_path__ + "assets/images/rbyearend-06-desktop.jpg?v=21d76d6f";